export interface GoPhotoUploadPortrait {
  count?: number;
  isError?: boolean;
  isPreloaded?: boolean;
  uuid: string;
}

interface SelectPortraitsOptions {
  hohSendsAllPortraits: boolean;
  portraits: GoPhotoUploadPortrait[];
  printingQueue: GoPhotoUploadPortrait[];
}

export function isHohAllPortraitsKiosk(slug: unknown): boolean {
  const kioskSlug = typeof slug === 'string' ? slug : '';
  return kioskSlug === 'hoh' || kioskSlug.includes('highlights-of-holland');
}

export function selectGoPhotoPortraits({
  hohSendsAllPortraits,
  portraits,
  printingQueue,
}: SelectPortraitsOptions): GoPhotoUploadPortrait[] {
  if (!hohSendsAllPortraits) {
    return printingQueue;
  }

  return portraits
    .filter((portrait) => portrait.isPreloaded && !portrait.isError)
    .map((portrait) => ({ uuid: portrait.uuid, count: 1 }));
}

export function areHohPortraitsStillLoading(
  hohSendsAllPortraits: boolean,
  portraits: GoPhotoUploadPortrait[]
): boolean {
  if (!hohSendsAllPortraits) {
    return false;
  }
  if (portraits.length === 0) {
    return true;
  }
  return portraits.some(
    (portrait) => !(portrait.isPreloaded || portrait.isError)
  );
}

export function expandPortraitCopies(
  portraits: GoPhotoUploadPortrait[]
): string[] {
  return portraits.flatMap((portrait) =>
    new Array(portrait.count || 1).fill(portrait.uuid)
  );
}

export function retryDelayWithJitter(
  attempt: number,
  delays: number[],
  randomValue = Math.random()
): number {
  const base = delays[attempt - 1] ?? 8000;
  const jitter = base * 0.25 * (randomValue * 2 - 1);
  return Math.max(0, Math.round(base + jitter));
}
